<template>
  <div>
    <List
      url="getDocumentsDocumentTypeList"
      deleteUrl="deleteDocumentsDocumentType"
      :tanle="tanle"
      :update="updateList"
      :data="searchData"
      @add="add"
      @edit="edit"
      :operat="operat"
      :isAdd="true"
    >
      <div slot="Filter">
        <el-input
          v-model="searchData.Key"
          placeholder="DocumentType"
          style="width: 300px; margin-left: 10px"
        ></el-input>
        <el-button
          @click="updateList++"
          type="primary"
          style="margin-left: 10px"
          >Search</el-button
        >
      </div>
    </List>
    <UpdateBox
      v-if="updateBlock"
      :updateType="updateType"
      :initForm="updateForm"
      :showSelect="true"
      :selectOptions="selectOptions"
      @close="updateBlock = false"
      @update="updateList++"
      @updateSelection="updateSelection"
    >
    </UpdateBox>
  </div>
</template>

<script>
import List from "../components/common/List.vue";
import UpdateBox from "../components/DocumentsDocumentType/UpdateBox.vue";
export default {
    components: {
        List,
        UpdateBox
    },
    data() {
        return {
            tanle: [
                { name: "ID", label: "Type ID" },
                { name: "DocumentType", label: "Document Type" },
                { name: "CreatedTime", label: "Created Time" }
            ],
            updateList: 0,
            updateBlock: false,
            updateType: "add",
            updateForm: {},
            searchData: {
                Key: ""
            },
            operat: [
                {
                    text: "Delete",
                    eventName: "delete",
                    type: "danger",
                    PretreatMethod: "confirmDelete"
                },
                {
                    text: "Edit",
                    eventName: "edit",
                    type: "primary",
                    method(data) {
                        return data.Status !== "1";
                    }
                }
            ],
            selectOptions: [
              {
                label: "若有所属上级，请选择",
                value: 0
              },
            ]
        };
    },
    created() {
      this.getSelectOptions();
    },
    methods: {
        add() {
            this.updateForm = {
                DocumentType: "",
                Pid: "0"
                // CreatedTime: "",
            };
            this.updateType = "add";
            this.updateBlock = true;
        },
        edit(val) {
            this.updateType = "edit";
            this.updateBlock = true;
            this.updateForm = Object.assign({}, val);
        },
        getSelectOptions() {
          this.$http.get("/getAllDocumentsDocumentType", {}, (resp)=>{
            if (resp.code == 0) {
              let data = resp.data
              if (data.length > 0) {
                let options = [{
                  label: "若有所属上级，请选择",
                  value: "0"
                }];
                data.forEach(item => {
                  let optionsTemp = {}
                  optionsTemp.label = item.DocumentType
                  optionsTemp.value = String(item.ID) 
                  options.push(optionsTemp);
                });
                this.selectOptions = options;
              }
            }
          });
        },
        updateSelection() {
          this.getSelectOptions();
        }
    },
    computed: {},
    watch: {}
};
</script>
